var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntraverseLogoWithIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 41,
    viewBox: "0 0 291 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2809 38.9826L58.4381 32.7232L59.2195 30.7533L51.4876 28.0842L49.4402 28.0044L38.2793 31.4597L38.2809 38.9826Z",
    fill: "url(#paint0_linear_18819_19562)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9387 38.9027L0.781418 32.6434L0 30.6735L7.73197 28.0044H9.7793L20.9411 31.4597L20.9387 38.9027Z",
    fill: "url(#paint1_linear_18819_19562)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0485 0.0205078L23.4521 1.53944V40.0205H35.8511V1.53944L34.2547 0.0205078H25.0485Z",
    fill: "url(#paint2_linear_18819_19562)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.903 24.4313C150.485 23.7438 151.708 22.7427 152.57 21.4278C153.432 20.1129 153.862 18.5355 153.862 16.6956C153.862 14.8796 153.431 13.308 152.57 11.9809C151.708 10.6538 150.486 9.63516 148.903 8.92504C147.319 8.21492 145.433 7.85986 143.245 7.85986H132.663V32.3066H138.356V25.4615H143.245C143.332 25.4615 143.411 25.4615 143.494 25.4615L148.239 32.3092H154.316L148.869 24.4513L148.903 24.4313ZM146.842 13.5699C147.727 14.3033 148.169 15.3452 148.169 16.6956C148.169 18.046 147.727 19.0937 146.842 19.8388C145.957 20.5844 144.653 20.9569 142.931 20.9563H138.356V12.4698H142.931C144.654 12.4698 145.957 12.8354 146.842 13.5664V13.5699Z",
    fill: "url(#paint3_linear_18819_19562)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M239.792 24.4313C241.376 23.7438 242.598 22.7427 243.459 21.4278C244.321 20.1129 244.752 18.5355 244.752 16.6956C244.752 14.8796 244.321 13.308 243.459 11.9809C242.598 10.6538 241.376 9.63516 239.792 8.92504C238.209 8.2155 236.323 7.86045 234.135 7.85986H223.553V32.3066H229.245V25.4615H234.135C234.222 25.4615 234.301 25.4615 234.384 25.4615L239.129 32.3092H245.206L239.758 24.4513L239.792 24.4313ZM237.732 13.5699C238.617 14.3033 239.059 15.3452 239.059 16.6956C239.059 18.046 238.617 19.0937 237.732 19.8388C236.847 20.5832 235.543 20.9558 233.82 20.9563H229.245V12.4698H233.82C235.543 12.4698 236.847 12.8356 237.732 13.5673V13.5699Z",
    fill: "url(#paint4_linear_18819_19562)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.147 12.4068H115.97V32.2436H121.628V12.4068H129.451V7.79688H108.147V12.4068Z",
    fill: "url(#paint5_linear_18819_19562)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.171 7.79688H190.547L182.616 25.6151L185.576 32.2436H185.589L196.171 7.79688Z",
    fill: "url(#paint6_linear_18819_19562)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.828 22.0458H217.178V17.6105H205.828V12.337H218.68V7.79688H200.205V32.2436H219.134V27.7035H205.828V22.0458Z",
    fill: "url(#paint7_linear_18819_19562)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.454 0L171.927 22.7093H164.351L166.235 18.1779L163.624 11.9047L157.579 25.5119L160.38 32.2435H160.385L162.564 27.0049H173.719L179.157 40.0411H184.773L168.077 0H162.454Z",
    fill: "url(#paint8_linear_18819_19562)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5208 7.79688V22.6282L87.3673 7.79688H82.6875V10.5646L88.9284 18.2086L100.429 32.2436H105.109V7.79688H99.5208Z",
    fill: "url(#paint9_linear_18819_19562)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6875 15.8989V32.2433H88.2753V22.744L82.6875 15.8989Z",
    fill: "url(#paint10_linear_18819_19562)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2324 7.79688H76.925V32.2184L71.2324 25.2609V7.79688Z",
    fill: "url(#paint11_linear_18819_19562)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.884 19.8986C264.013 19.3833 263.088 18.9674 262.125 18.6588C261.127 18.3334 260.112 18.0594 259.086 17.8381C258.061 17.6164 257.13 17.3952 256.292 17.1746C255.455 16.954 254.78 16.6455 254.267 16.2491C254.021 16.0686 253.823 15.8314 253.689 15.5577C253.556 15.284 253.49 14.982 253.498 14.6775C253.496 14.1724 253.662 13.6808 253.97 13.2806C254.284 12.8615 254.779 12.5297 255.454 12.2852C256.129 12.0408 257.026 11.9185 258.143 11.9185C259.277 11.9273 260.404 12.0858 261.496 12.39C262.241 12.5934 262.968 12.8569 263.67 13.1775L266.65 9.53478C265.536 8.84066 264.231 8.30814 262.736 7.9372C261.245 7.56588 259.714 7.37823 258.178 7.37842C255.873 7.37842 253.958 7.72184 252.433 8.40867C250.908 9.09551 249.773 10.0152 249.028 11.1677C248.288 12.3047 247.899 13.6349 247.911 14.9918C247.911 16.2724 248.161 17.3376 248.661 18.1874C249.156 19.0312 249.852 19.7392 250.687 20.2479C251.562 20.783 252.5 21.2054 253.481 21.5051C254.494 21.8195 255.501 22.0872 256.502 22.3084C257.503 22.5296 258.428 22.7624 259.278 23.0069C260.128 23.2513 260.809 23.5657 261.321 23.9498C261.567 24.126 261.766 24.3599 261.9 24.6309C262.034 24.9019 262.099 25.2017 262.09 25.5039C262.096 25.9968 261.923 26.4751 261.601 26.8485C261.274 27.2327 260.768 27.5412 260.082 27.774C259.395 28.0068 258.493 28.1232 257.375 28.1232C255.891 28.1201 254.417 27.8784 253.009 27.4073C252.016 27.0789 251.122 26.6873 250.327 26.2322L247.395 29.8165L247.387 29.8345C248.48 30.6727 249.93 31.3537 251.735 31.8776C253.568 32.4055 255.467 32.6701 257.375 32.6633C259.68 32.6633 261.601 32.3141 263.137 31.6156C264.674 30.9171 265.821 29.9975 266.577 28.8566C267.326 27.7418 267.721 26.4275 267.712 25.0848C267.712 23.8276 267.45 22.774 266.927 21.9242C266.421 21.0923 265.72 20.3968 264.884 19.8986Z",
    fill: "url(#paint12_linear_18819_19562)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.21 22.0463V27.704H290.471L286.757 32.2441H271.588V7.79736H290.062V12.3375H277.21V17.611H288.56V22.0463H277.21Z",
    fill: "url(#paint13_linear_18819_19562)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18819_19562",
    x1: 42.8553,
    y1: 41.6237,
    x2: 51.6536,
    y2: 26.3849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18819_19562",
    x1: 8.97633,
    y1: 37.375,
    x2: 14.5285,
    y2: 27.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F01642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EE194D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#EC1F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E82778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E43198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#DF3DC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18819_19562",
    x1: 19.7701,
    y1: 37.8942,
    x2: 39.7917,
    y2: 3.21722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E92571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E43199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E03AB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DE40C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18819_19562",
    x1: 133.774,
    y1: 31.0544,
    x2: 156.864,
    y2: 10.6059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18819_19562",
    x1: 224.664,
    y1: 31.0544,
    x2: 247.754,
    y2: 10.6059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18819_19562",
    x1: 109.241,
    y1: 30.9889,
    x2: 132.28,
    y2: 10.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18819_19562",
    x1: 183.312,
    y1: 30.9889,
    x2: 203.038,
    y2: 20.0513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18819_19562",
    x1: 201.177,
    y1: 30.9889,
    x2: 223.693,
    y2: 13.5545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_18819_19562",
    x1: 158.975,
    y1: 37.9861,
    x2: 194.385,
    y2: 13.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_18819_19562",
    x1: 83.8382,
    y1: 30.9889,
    x2: 107.009,
    y2: 9.73795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_18819_19562",
    x1: 82.9743,
    y1: 31.4045,
    x2: 92.4937,
    y2: 28.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_18819_19562",
    x1: 71.5246,
    y1: 30.965,
    x2: 81.7978,
    y2: 28.5704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_18819_19562",
    x1: 248.43,
    y1: 31.3658,
    x2: 271.923,
    y2: 12.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_18819_19562",
    x1: 272.557,
    y1: 30.9894,
    x2: 295.06,
    y2: 13.6071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntraverseLogoWithIcon);
export default __webpack_public_path__ + "static/media/Intraverse_Logo_With_Icon.1206b7e58b1828e8c7dda6327dd6cdb7.svg";
export { ForwardRef as ReactComponent };